import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import {
  AffiliatesSI,
  PoliciesProjectDetail,
  ProjectData,
  ProjectInfoSI,
  ProjectsDetail,
  ProjectsDetailSI,
  ProjectsSI,
  SaveProjectInfoSI,
} from '@views/interfaces/services/projects';
import { MyPolicies, TakerInterface } from '@views/interfaces';

@Injectable({ providedIn: 'root' })
export class ProjectsService {
  constructor(private httpClient: HttpClient) {}

  public async getMyPolicies(
    params: MyPolicies
  ): Promise<PoliciesProjectDetail> {
    let queryParams = new HttpParams();
    for (const param in params)
      queryParams = queryParams.append(param, params[param]);

    const result = await firstValueFrom<
      ResponseCommonSI<PoliciesProjectDetail>
    >(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.USER_POLICIES}`, {
        params: queryParams,
      })
    );
    return result.payload;
  }

  async getMyProjects(): Promise<ProjectsDetail> {
    const result = await firstValueFrom<ResponseCommonSI<ProjectsDetail>>(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.USER_PROJECTS}`)
    );
    return result.payload;
  }

  async getProjects(): Promise<ProjectsSI> {
    const result = await firstValueFrom<ResponseCommonSI<ProjectsSI>>(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.PROJECTS}`)
    );
    return result.payload;
  }

  async getProjectsAll(spinner: boolean = true): Promise<ProjectData> {
    const result = await firstValueFrom<ResponseCommonSI<ProjectData>>(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.POLICES_VALIDATION_ALL}`, {
        params: { spinner },
      })
    );
    return result.payload;
  }

  async getDetailProject(id: string): Promise<ProjectsDetailSI> {
    const result = await firstValueFrom<ResponseCommonSI<ProjectsDetailSI>>(
      this.httpClient.get(
        `${BASE_URL}${ENDPOINTS.DETAILS_PROJECT}`.replace(':id', id)
      )
    );
    return result.payload;
  }

  async getValidations(): Promise<{ isValid: boolean }> {
    const result = await firstValueFrom<ResponseCommonSI<{ isValid: boolean }>>(
      this.httpClient.get(`${BASE_URL}${ENDPOINTS.VALIDATION_ALL}`)
    );
    return result.payload;
  }

  async deleteBeneficiary(idPolicyData: string): Promise<boolean> {
    const result = await firstValueFrom<ResponseCommonSI<boolean>>(
      this.httpClient.delete(
        `${BASE_URL}${ENDPOINTS.DELETE_POLICY.replace(
          ':idPolicyData',
          idPolicyData
        )}/`
      )
    );
    return result.payload;
  }

  async getProjectInfo(idProject: string): Promise<ProjectInfoSI> {
    idProject = idProject ? idProject : '';
    const result = await firstValueFrom<ResponseCommonSI<ProjectInfoSI>>(
      this.httpClient.get(
        `${BASE_URL}${ENDPOINTS.PROJECT_GENERAL.replace(
          ':IdProject',
          idProject
        )}`
      )
    );
    return result.payload;
  }

  async saveProjectInfo(body: SaveProjectInfoSI): Promise<SaveProjectInfoSI> {
    const result = await firstValueFrom<ResponseCommonSI<SaveProjectInfoSI>>(
      this.httpClient.post(
        `${BASE_URL}${ENDPOINTS.PROJECT_GENERAL.replace(':IdProject', '')}`,
        body
      )
    );
    return result.payload;
  }

  async getAffiliates(rut: string): Promise<AffiliatesSI> {
    const result = await firstValueFrom<ResponseCommonSI<AffiliatesSI>>(
      this.httpClient.get(
        `${BASE_URL}${ENDPOINTS.COMPANY_AFFILIATES.replace(':rut', rut)}`
      )
    );
    return result.payload;
  }

  async getAffiliatesTaker(rut: string): Promise<TakerInterface> {
    const result = await firstValueFrom<ResponseCommonSI<TakerInterface>>(
      this.httpClient.get(
        `${BASE_URL}${ENDPOINTS.TAKER_NEW.replace(
          ':rut',
          rut
        )}?isNewConstuctionCompany=true`
      )
    );
    return result.payload;
  }

  async deleteProjectAll(projectId: string) {
    const result = await firstValueFrom<ResponseCommonSI<any>>(
      this.httpClient.delete(
        `${BASE_URL}${ENDPOINTS.POLICIES_DELETE_ALL.replace(
          ':idProject',
          projectId
        )}`
      )
    );
    return result.payload;
  }
  async getPoliciyBase64(nroPolicy: string) {
    const result = await firstValueFrom<ResponseCommonSI<string>>(
      this.httpClient.get(
        `${BASE_URL}${ENDPOINTS.POLICY_DOWNLOAD_BASE64.replace(
          ':id',
          nroPolicy
        )}`
      )
    );
    return result.payload;
  }
}
